export default __webpack_public_path__ + "static/media/bl-gift-card-new.3317bb52.png";